
import { supabase } from '@/integrations/supabase/client';
import { serviceLogger } from '@/utils/debug';

export interface SystemSetting {
  key: string;
  value: any;
  description?: string;
  created_at: string;
  updated_at: string;
}

export const systemSettingsService = {
  async fetchSettings(): Promise<SystemSetting[]> {
    serviceLogger.log('🔥 Fetching system settings');
    
    const { data, error } = await supabase
      .from('system_settings')
      .select('*')
      .order('key');

    if (error) {
      serviceLogger.error('🔥 Error fetching system settings:', error);
      serviceLogger.captureError(error);
      throw error;
    }

    return data || [];
  },

  async updateSetting(key: string, value: any): Promise<void> {
    serviceLogger.log('🔥 Updating system setting:', { key, value });
    
    const { error } = await supabase
      .from('system_settings')
      .upsert({
        key,
        value: JSON.stringify(value),
        updated_at: new Date().toISOString()
      });

    if (error) {
      serviceLogger.error('🔥 Error updating system setting:', error);
      serviceLogger.captureError(error);
      throw error;
    }
  },

  async getSetting(key: string): Promise<any> {
    serviceLogger.log('🔥 Getting system setting:', key);
    
    const { data, error } = await supabase
      .from('system_settings')
      .select('value')
      .eq('key', key)
      .limit(1);

    if (error) {
      serviceLogger.error('🔥 Error getting system setting:', error);
      serviceLogger.captureError(error);
      throw error;
    }

    return data && data.length > 0 ? data[0].value : null;
  }
};
